// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { AgentCustomSettings } from '../agentCustomSettings';

export class UpdateCustomSettings {
  settings: AgentCustomSettings;
}
